/**
 * Generates a key from a given name by converting it to lowercase and replacing spaces with hyphens.
 * @param name - The name to convert.
 * @returns The generated key.
 */
export function keyFromName(name: string): string {
  return name.toLowerCase().replace(/\s+/g, '-')
}

/**
 * Finds a child node by its key and returns its value.
 * @param key - The key of the child node to find.
 * @returns The value of the found child node, or undefined if no child node with the given key is found.
 */
export const mapChildren = (key: string, node: any): any => {
  const child = node.children.find((c: any) => c.key === key)
  return child?.value ?? undefined
}
